<template>
  <div class="container">
    <div class="landingFooter" id="contact">
      <div>
        <div class="rowww mb-5">
          <!-- data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine" data-aos-delay="100" data-aos-duration="1000" -->
          <div class="bout">
            <h2>
              <app-i18n
                code="saryahLanding.footer.about"
              ></app-i18n>
            </h2>
            <h5>
              <app-i18n
                code="saryahLanding.footer.aboutContent"
              ></app-i18n>
            </h5>
          </div>

          <div
            class="col-lg-5 contact q-pa-none"
            style="color: #fff"
          >
            <h2>
              <app-i18n
                code="saryahLanding.footer.contactUs"
              ></app-i18n>
            </h2>
            <div class="">
              <div>
                <h5 class="mb-3 c-flex">
                  <i
                    class="far fa-envelope mr-3"
                    style="color: #fff"
                  ></i
                  ><span>
                    <app-i18n
                      code="saryahLanding.footer.mail"
                    ></app-i18n>
                  </span>
                </h5>
              </div>
              <div>
                <div class="c-flex">
                  <div>
                    <i
                      class="fas fa-map-marker-alt mr-3"
                      style="color: #fff"
                    ></i>
                  </div>
                  <div style="cursor: pointer">
                    <app-i18n
                      code="saryahLanding.footer.location"
                    ></app-i18n>
                    <!-- Egypt : 378 Abou Quer, Mustafa Kamel WA Bolkli Sidi Gaber, Alexandria Governorate -->
                    <!-- Saudi Arabia : Ajdan Walk, Ground Floor, Al Khobar 34429 -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="bout">
            <h2>
              <app-i18n
                code="saryahLanding.footer.downloadTheApp"
              ></app-i18n>
            </h2>
            <!-- <h5 >
              <app-i18n code="saryahLanding.footer.aboutContent"></app-i18n>
            </h5> -->

            <div class="buttons">
              <div class="download-container">
                <div class="icon">
                  <img src="/apple.svg" alt="" />
                </div>
                <div class="desc">
                  <p>{{ $t('common.getItOn') }}</p>
                  <h5>{{ $t('common.appStore') }}</h5>
                </div>
              </div>

              <div class="download-container">
                <div class="icon">
                  <img src="/play-store.svg" alt="" />
                </div>
                <div class="desc">
                  <p>{{ $t('common.getItOn') }}</p>
                  <h5>{{ $t('common.playStore') }}</h5>
                </div>
              </div>
            </div>
          </div>
          <!-- data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine" data-aos-delay="200" data-aos-duration="2000" -->
        </div>

        <div class="copyRights">
          <div class="rowwww">
            <div>
              <h5>
                © {{ new Date().getFullYear() }}
                <app-i18n
                  code="saryahLanding.footer.copyRight"
                ></app-i18n>
              </h5>
            </div>

            <div
              class="text-center flex gap-5 terms"
              style="padding: 0"
            >
              <h5>
                <router-link
                  :to="{ path: goToPrivacyPolicy() }"
                  target="_blank"
                  style="color: #fff"
                >
                  <app-i18n
                    code="common.privacyPolicy"
                    style="cursor: pointer"
                    class="padding-r"
                  ></app-i18n>
                </router-link>
              </h5>
              <h5>
                <router-link
                  :to="{ path: goToTermsAndConditions() }"
                  target="_blank"
                  style="color: #fff"
                >
                  <app-i18n
                    code="common.termsAndConditions"
                    style="cursor: pointer"
                    class="padding-r"
                  ></app-i18n>
                </router-link>
              </h5>
            </div>

            <div class="socialIconFoot">
              <a href="https://www.facebook.com/"
                ><i class="fab fa-facebook-f"></i
              ></a>
              <a href="https://twitter.com/"
                ><i class="fab fa-twitter"></i
              ></a>
              <a href="https://www.linkedin.com/"
                ><i class="fab fa-linkedin-in"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { routerAsync } from '@/app-module';
import { mapGetters } from 'vuex';
import i18n from '@/vueI18n';

export default {
  name: 'app-landing-footer',

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      // isMobile: 'layout/isMobile',
      currentLanguageCode:
        'saryahLanding/landing/currentLanguageCode',
    }),
    isRTL() {
      // return this.currentLanguageCode == 'ar'
      return i18n.locale == 'ar';
    },
    language() {
      return localStorage.getItem('language');
    },
    privacy_policy_url() {
      const language = localStorage.getItem('language');
      // this.$router.push(`/${language}/privacy-policy`)
      return `/${language}/privacy-policy`;
    },
  },

  methods: {
    goToPrivacyPolicy() {
      const language = localStorage.getItem('language');
      // return `/${language}/privacy-policy`
      console.log('language', language);
      console.log('rtl', this.isRTL);
      if (this.isRTL) {
        return `/ar/privacy-policy`;
        // this.$router.push(`/ar/privacy-policy`)
      } else {
        return `/en/privacy-policy`;
        // this.$router.push(`/en/privacy-policy`)
      }
      // this.$router.push(`/${language}/privacy-policy`)
    },
    goToTermsAndConditions() {
      const language = localStorage.getItem('language');
      console.log('language', language);
      console.log('rtl', this.isRTL);
      if (this.isRTL) {
        return `/ar/terms-and-conditions`;
      } else {
        return `/en/terms-and-conditions`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.c-flex {
  display: flex;
  align-items: center;
}

.rowww {
  display: flex;
  gap: 40px;
  justify-content: space-between;
  text-align: start !important;
}
.rowwww {
  display: flex;
  gap: 15px;
  justify-content: space-between;
  text-align: start !important;
}
@media (width < 768px) {
  .rowww {
    flex-direction: column;
    gap: 20px;
  }
  .rowwww {
    flex-direction: column;
    align-items: center !important;
  }

  .rowwww > div {
    text-align: center !important;
  }
}

.rowww > div {
  flex: 1;
}
.copyRights {
  border-top: 1px solid #eee;
  padding-top: 10px;
}
.copyRights {
  h5 {
    font-size: 15px !important;
  }
}
.copyRights .row {
  justify-content: space-between;
}
.terms {
  display: flex;
  gap: 20px;
}
.terms h5 {
  font-size: 15px !important;
}

.landingFooter {
  margin-top: 100px;
  background: linear-gradient(
    180deg,
    #ff6286ff,
    #ff5e84ff,
    #ff5a81ff,
    #ff567fff,
    #ff527cff,
    #ff4e7aff,
    #ff4a77ff
  );
  background-size: cover !important;
  color: #fff;
  padding: 40px 40px 10px 40px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.q-chip {
  background: transparent !important;
}

.socialIconFoot {
  display: flex;
  align-items: center;
  gap: 25px;
  i {
    font-size: 16px;
    color: #fff;
  }

  i:hover,
  i:focus {
    color: #da3b30;
  }
}

.q-chip .q-avatar {
  border-radius: unset !important;
  margin-right: 20px !important;
  width: unset !important;
}
h2 {
  font-size: 30px !important;
}
h5 {
  font-size: 16px !important;
}

@media (width < 768px) {
  h2 {
    font-size: 25px !important;
  }
  h5 {
    font-size: 15px !important;
  }
}
@media screen and (max-width: 990px) {
  .landingFooter {
    text-align: center;

    .about {
      margin-right: unset !important;
    }
  }
  .contac {
    border: none !important;
  }
}

.buttons {
  flex-direction: column !important;
  align-items: start !important;
  gap: 20px;
}
.buttons img {
  height: 20px !important;
}
.download-container {
  padding: 8px 25px;
  gap: 25px;
}
.buttons p {
  font-size: 12px;
}
.buttons h5 {
  font-size: 14px;
}
.buttons p,
.buttons h5 {
  line-height: unset;
}
</style>
